import { render, staticRenderFns } from "./VxTableSuggest.vue?vue&type=template&id=5ac06158"
import script from "./VxTableSuggest.vue?vue&type=script&lang=js"
export * from "./VxTableSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports